<template>
	<page>
		<module>
			<view-list work-type="47" ref="view" selector :view-config="auth('b_quality_work_after_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="质检单号">
							<c-input name="quality_code"></c-input>
						</m-search-item>
						<m-search-item label="工单编号">
							<c-input name="work_code"></c-input>
						</m-search-item>
						<m-search-item label="产品编号">
							<c-input name="product_code"></c-input>
						</m-search-item>
						<m-search-item label="产品名称">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="规格名称">
							<c-input name="product_spec"></c-input>
						</m-search-item>
						<m-search-item label="质检人员">
							<c-select name="test_user_ids" async multiple @search="searchTestUser" ></c-select>
						</m-search-item>
						<m-search-item label="处理方式">
							<c-select name="after_types" :options="afterTypeDic" multiple ></c-select>
						</m-search-item>
						<m-search-item label="处理状态">
							<c-select name="after_states" :options="afterStateDic" multiple ></c-select>
						</m-search-item>
						<m-search-item label="质检时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_quality_work_after_export')" v-lock="lock('b_quality_work_after_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_quality_work_after_export')" v-lock="lock('b_quality_work_after_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
				</template>

				<template #batchOperate="{data}">
					<c-button v-if="auth('b_quality_work_after_export')" v-lock="lock('b_quality_work_after_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_quality_work_after_export')" v-lock="lock('b_quality_work_after_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_quality_work_after_print')" v-lock="lock('b_quality_work_after_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
					<c-button v-if="auth('b_quality_work_after_work')" v-lock="lock('b_quality_work_after_work')" color="main" prepend-icon="tf-deliver" @click="createWork()">生成工单</c-button>
				</template>

				<!--处理方式-->
				<template #after_type="{data}">
					<c-state dict="afterTypeDic" :value="data.after_type"></c-state>
				</template>

				<!--处理状态-->
				<template #after_state="{data}">
					<c-state dict="afterStateDic" :value="data.after_state"></c-state>
					<span v-if="data.after_state == 2"></span>
				</template>

				<!--质检单号-->
				<template v-if="auth('m_quality_work')" #quality_code="{data}">
					<c-link @click="globalDialog('qualityWorkDetail', {props: {id: data.quality_id}})">{{data.quality_code}}</c-link>
				</template>

				<!--工单编号-->
				<template v-if="auth('m_work')" #work_code="{data}">
					<c-link @click="globalDialog('workDetail', {props: {id: data.work_id}})">{{data.work_code}}</c-link>
				</template>
				
				<!--返工单号-->
				<template v-if="auth('m_work')" #ref_work_code="{data}">
					<c-link @click="globalDialog('workDetail', {props: {id: data.ref_work_id}})">{{data.ref_work_code}}</c-link>
				</template>
				
				<c-table-column
					type="button"
					label="操作"
					width="200"
					button-limit="3"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_quality_work_after_work')" v-lock="lock('b_quality_work_after_work')" :disabled="!(data.after_state == 1 && data.after_type == 1)" icon="tf-deliver" @click="editState(data.id)">已处理</c-table-button>
						<c-table-button v-if="auth('b_quality_work_after_work')" v-lock="lock('b_quality_work_after_work')" :disabled="!(data.after_state == 1 && data.after_type == 2)" icon="tf-deliver" @click="createWork(data.id)">生成工单</c-table-button>
						<c-table-button v-if="auth('b_quality_work_after_print')" v-lock="lock('b_quality_work_after_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id)">打印</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	import {mapState} from 'vuex'
	
	export default {
		components: {
			
		},

		data() {
			return {
			}
		},
		
		computed: {
			// 获取dictName选项数据
			...mapState(['userInfo', 'afterTypeDic', 'afterStateDic'])
		},
		
		mounted() {
		    this.$bus.$on('work.after.list.update', data => {
		        // 刷新列表
		        this.$refs.view.update();
		    });
		},
		
		beforeDestroy() {
			this.$bus.$off('work.after.list.update');
		},
		
		methods: {
			/**生成工单记录*/
			createWork(id){
				var ids = [];
				if(id){
					ids.push(id);
				}else{
					this.$refs.view.$refs.list.getData('selected').forEach(item => {
						ids.push(item.id);
					});
				}
				this.$confirm({
					message:'将按原工单相关信息重新新增一条待开始的工单，状态为【未开始】，是否确定操作？已处理系统将自动跳过',  // 提示内容,
					buttonName: '确定生成',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url:'/test/defects/createWork',
							data: {
								ids: ids
							},
							loading: true,
							success:data => {
								this.$message({
									message:'生成工单成功',  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.update();
							}
						})
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			
			/**标记为已处理*/
			editState(id){
				this.$confirm({
					message:'是否确定已完成报废操作？',  // 提示内容,
					buttonName: '确定已报废',  // 确定按钮文字
					cancelButton: true,  // 是否显示取消按钮
					resolve: () => {
						this.request({
							url:'/test/defects/editState',
							data: {
								id: id
							},
							loading: true,
							success:data => {
								this.$message({
									message:'操作成功',  // 提示内容,
									type: 'success'
								});
								//刷新
								this.$refs.view.update();
							}
						})
					},  // 确定按钮回调
					cancel: () => {},  // 取消按钮回调
				});
			},
			
			/*******搜索【员工】下拉框信息*****************/
			searchTestUser(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'SYSUSER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
		}
	}
</script>

<style lang="stylus" scoped>
</style>